import { Injectable } from "@angular/core";
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from "@angular/common/http";

import { Observable } from "rxjs";

import {
  LanguagesISO639$1FormatEnum,
  TranslocoConfig,
} from "@core/config/transloco.config";
import { LANGUAGE_KEY } from "@shared/constants/storage-keys";

@Injectable()
export class AcceptLanguageInterceptor implements HttpInterceptor {
  private defaultLanguage: LanguagesISO639$1FormatEnum =
    TranslocoConfig.defaultLang;

  private get language(): LanguagesISO639$1FormatEnum {
    return (
      (localStorage.getItem(LANGUAGE_KEY) as LanguagesISO639$1FormatEnum) ||
      this.defaultLanguage
    );
  }

  public intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    request = request.clone({
      headers: request.headers.set("Accept-Language", this.language),
    });

    return next.handle(request);
  }
}
